import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  standalone: true,
  template: `
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; text-align: center; font-family: Arial, sans-serif;">
      <h1 style="font-size: 3rem; color: #dc3545; margin-bottom: 1rem;">403</h1>
      <h2 style="font-size: 1.5rem; color: #6c757d; margin-bottom: 1rem;">Access Denied</h2>
      <p style="font-size: 1rem; color: #868e96; max-width: 400px; line-height: 1.5;">
        You don't have permission to access this page. Please contact your administrator if you believe this is an error.
      </p>
      <button 
        style="margin-top: 2rem; padding: 0.75rem 1.5rem; background-color: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 1rem;"
        onclick="window.history.back()"
      >
        Go Back
      </button>
    </div>
  `
})
export class NotFoundComponent {
}
